import { Button, Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import { StyledButtons } from "../AddFieldsModal/styles";
import { StyledTableFooter, StyledTableFooterWrapper } from "../ExportTable/styles";

import type { ExportFooterProps } from "./type";

export const ExportFooter = ({
    isVisible,
    isDisabledCancel,
    isDisabledSave,
    isLoading,
    saveTooltipContent,
    onCancel,
    onSave,
}: ExportFooterProps) => {
    return isVisible ? (
        <StyledTableFooter>
            <StyledTableFooterWrapper>
                <StyledButtons>
                    <Button
                        type="flat"
                        isDisabled={isDisabledCancel}
                        onClick={onCancel}
                    >
                        {translate("si.management.sf.settings_export.modal.add_fields.btn.cancel")}
                    </Button>

                    <Tooltip
                        enabled={isDisabledSave}
                        placement="top"
                        content={<I18n translatable={{ key: saveTooltipContent }} />}
                    >
                        <Button
                            type="primary"
                            isLoading={isLoading}
                            isDisabled={isDisabledSave}
                            onClick={onSave}
                        >
                            {translate("si.management.sf.settings_export.settings.btn.save.label")}
                        </Button>
                    </Tooltip>
                </StyledButtons>
            </StyledTableFooterWrapper>
        </StyledTableFooter>
    ) : null;
};
